import { Guardian } from '@xaamin/guardian';

Guardian.define('catalogo.cliente.subir.archivo', (user) => {
  return user.can('catalogo.cliente.subir.archivo');
});

Guardian.define('catalogo.cliente.listar.archivos', (user) => {
  return user.can('catalogo.cliente.listar.archivos');
});
